import styled from '@emotion/styled'

export const List = styled.ul(({ theme: { fonts, colors } }) => ({
  margin: '2rem 0',
  color: colors.text,
  fontFamily: fonts.fontFamily,
  fontSize: fonts.fontSize,
  lineHeight: '28px',
}))
